import _implicitStylesheets from "./emptyState.css";
import _implicitScopedStylesheets from "./emptyState.scoped.css?scoped=true";
import _axImage from "ax/image";
import _wdsButton from "wds/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="label${0}"${"a0:type-style"}${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<p class="description${0}" type-style="body-2"${2}>${"t1"}</p>`;
const stc0 = {
  classMap: {
    "container": true
  },
  key: 0
};
const stc1 = {
  "empty-state-image": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind, h: api_element} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_custom_element("ax-image", _axImage, {
    classMap: stc1,
    props: {
      "height": $cmp.imgHeight,
      "width": "100%",
      "imgSrc": $cmp.imgSrc,
      "alt": $cmp.alt
    },
    key: 1
  }), api_static_fragment($fragment1, 3, [api_static_part(0, {
    attrs: {
      "type-style": $cmp.labelTypeStyle
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.label))]), $cmp.description ? api_static_fragment($fragment2, 5, [api_static_part(1, null, api_dynamic_text($cmp.description))]) : null, $cmp.ctaLabel ? api_custom_element("wds-button", _wdsButton, {
    props: {
      "size": "small",
      "label": $cmp.ctaLabel,
      "href": $cmp.ctaHref
    },
    key: 6,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleCtaClick))
    }
  }) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2r25c54jaei";
tmpl.legacyStylesheetToken = "undefined-_emptyState";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
